import React from 'react';
import classNames from 'classnames';

import css from './Select.css';

const Select = ({
  selectClassName,
  className,
  errorClassName,
  labelClassName,
  containerClassName,
  label = null,
  error = null,
  children = null,
  markRequired = false,
  isValidation = true,
  ...rest
}) => {
  const containerClasses = classNames(
    css.container,
    { [css.validation]: isValidation },
    containerClassName
  );
  const classes = classNames(selectClassName, css.select, className, {
    [css.selectError]: !!error,
  });
  const labelClasses = classNames(css.text, labelClassName);
  const errorClasses = classNames(css.error, errorClassName);

  return (
    <div className={containerClasses}>
      <label className={css.label}>
        {label && (
          <span className={labelClasses}>
            {label}
            {markRequired && '*'}
          </span>
        )}
        <select className={classes} {...rest} required>
          {children}
        </select>
      </label>
      {error && isValidation && <span className={errorClasses}>{error}</span>}
    </div>
  );
};

export default Select;
